(function(){
  var STORAGE_KEY='wl_welcome_shown_v1';

  function q(id){ return document.getElementById(id); }

  function open(){
    var overlay=q('welcome-overlay');
    var modal=q('welcome-modal');
    if(!overlay||!modal) return;
    overlay.classList.add('active');
    modal.classList.add('active');
    modal.focus();
    spawnBalloons();
  }

  function close(){
    var overlay=q('welcome-overlay');
    var modal=q('welcome-modal');
    overlay&&overlay.classList.remove('active');
    modal&&modal.classList.remove('active');
    try{ localStorage.setItem(STORAGE_KEY,'1'); }catch(e){}
  }

  function spawnBalloons(){
    var area=document.querySelector('.wm-balloons');
    if(!area) return;
    area.innerHTML='';
    var colors=['#ff6b6b','#ffd93d','#6bcBef','#a29bfe','#55efc4','#fd79a8'];
    for(var i=0;i<24;i++){
      var b=document.createElement('div');
      b.className='wm-balloon';
      var x=(Math.random()*100).toFixed(2)+'%';
      var delay=(Math.random()*2).toFixed(2)+'s';
      var dur=(8+Math.random()*6).toFixed(2)+'s';
      var drift=((Math.random()*2-1)*20).toFixed(0)+'vw';
      b.style.left=x;
      b.style.setProperty('--c',colors[i%colors.length]);
      b.style.setProperty('--x',drift);
      b.style.animation='floatUp '+dur+' linear '+delay+' forwards';
      var s=document.createElement('div');
      s.className='wm-string';
      b.appendChild(s);
      area.appendChild(b);
    }
  }

  function init(){
    if (document.readyState==='loading') { document.addEventListener('DOMContentLoaded', init); return; }
    try{ if(localStorage.getItem(STORAGE_KEY)==='1') return; }catch(e){}
    var overlay=q('welcome-overlay');
    var modal=q('welcome-modal');
    if(!overlay||!modal) return;
    var ok=modal.querySelector('.wm-ok');
    var cls=modal.querySelector('.wm-close');
    overlay.addEventListener('click', close);
    ok&&ok.addEventListener('click', close);
    cls&&cls.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
    setTimeout(open, 600); // show after short delay
  }

  init();
})();


